module.exports = __webpack_public_path__ + "static/media/hn.3a092e6c.svg";